"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDown, Loader2 } from "lucide-react";
export function CardSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="animate-pulse rounded-lg bg-card p-3"><div className="mb-2 flex items-center justify-between"><div className="h-4 w-16 rounded-full bg-muted" /><div className="h-3 w-10 rounded bg-muted" /></div><div className="mb-2 h-4 w-3/4 rounded bg-muted" /><div className="h-3 w-1/2 rounded bg-muted" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function EmptyState(t0) {
  const $ = _c(7);
  const {
    icon: Icon,
    label
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <p className="text-sm font-medium text-foreground">{label}</p>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="rounded-lg bg-card p-8 text-center">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function LoadMoreButton(t0) {
  const $ = _c(7);
  const {
    loading,
    onClick,
    label
  } = t0;
  let t1;
  if ($[0] !== loading) {
    t1 = loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ChevronDown className="h-4 w-4" />;
    $[0] = loading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== loading || $[4] !== onClick || $[5] !== t1) {
    t2 = <button onClick={onClick} disabled={loading} className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-card px-4 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-muted disabled:opacity-50 cursor-pointer">{t1}{label}</button>;
    $[2] = label;
    $[3] = loading;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}